export enum ContractStatus {
  DRAFT = 'draft',
  UNPUBLISHED = 'unpublished',
  PUBLISHED = 'published',
  SENT = 'sent',
  VIEWED = 'viewed',
  SIGNED = 'signed',
  FINAL_VALIDATED = 'final_validated',
}

export enum ContractTitle {
  VALIDATION_CONTRACT = 'VALIDATION CONTRACT',
  MODERATOR_CONTRACT = 'MODERATOR CONTRACT',
  ADMIN_CONTRACT = 'ADMIN CONTRACT',
}

export enum SignMethod {
  DRAW = 'DRAW',
  UPLOAD = 'UPLOAD',
  TEXT = 'TEXT',
}

export interface Contract {
  id: string;
  title: ContractTitle;
  contentHtml: string;
  contentPdfUrl?: string | null;
  status: ContractStatus;
  contractHash: string;
  createdAt: string;
  updatedAt: string;
  createdBy?: {
    id: number;
    name: string;
    email?: string;
  } | null;
  assignedTo?: {
    id: number;
    name: string;
    email?: string;
  } | null;
}

export interface Signature {
  id: string;
  contractId: string;
  userId: number;
  signatureData: string;
  signMethod: SignMethod;
  ipAddress?: string | null;
  userAgent?: string | null;
  signedAt: string;
}

export interface CreateContractDto {
  title: ContractTitle;
  contentHtml: string;
  contentPdfUrl?: string;
}

export interface UpdateContractDto {
  title?: ContractTitle;
  contentHtml?: string;
  contentPdfUrl?: string | null;
}

export interface AssignContractDto {
  assignedTo: number;
}

export interface SignContractDto {
  signatureData: string;
  signMethod: SignMethod;
}

export interface EligibleUser {
  id: number;
  name: string;
  email?: string;
  bestScore: number | null;
  contractAlreadyAssigned: boolean;
}

export interface EligibleUsersResponse {
  total: number;
  minScore: number;
  users: EligibleUser[];
}

export interface VerifyHashResponse {
  contractId: string;
  storedHash: string;
  computedHash: string;
  valid: boolean;
}

export interface ContractViewResponse extends Contract {
  readOnly: boolean;
  personalizedContent?: string;
}


